import { Descriptions } from '@procurify/ui'

import { useFormatDate } from '@webapp/core/components/FormattedDate/useFormatDate'
import { useProcurifyIntl } from '@webapp/hooks'
import { type Vendor } from '@webapp/models'
import messages from './messages'

export interface IVendorRequestInformationProps {
  vendorRequest: Vendor['vendor_request']
}

export const VendorRequestInformation = ({
  vendorRequest,
}: IVendorRequestInformationProps) => {
  const intl = useProcurifyIntl()
  const formatDate = useFormatDate()

  return (
    <Descriptions>
      <Descriptions.Item
        label={intl.formatMessage(messages.vendorRequestRequesterLabel)}
      >
        {vendorRequest.requester}
      </Descriptions.Item>
      <Descriptions.Item
        label={intl.formatMessage(messages.vendorRequestNextApproverLabel)}
      >
        {vendorRequest.next_approver}
      </Descriptions.Item>
      <Descriptions.Item
        label={intl.formatMessage(messages.vendorRequestSubmittedDateLabel)}
      >
        {formatDate(vendorRequest.submitted_date, {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        })}
      </Descriptions.Item>
    </Descriptions>
  )
}
